import { FunctionalComponent, h } from "preact";
import Nav from "./Nav";

const Header: FunctionalComponent = () => (
  <div class="header">
    <Nav />
  </div>
);

export default Header;
